<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="pl-2">
      <v-icon class="flex-grow-0 pr-4">
        explore
      </v-icon>
      <span>Background Overview</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row
        v-for="(item, index) of summaryItems"
        :key="index"
        class="text-caption"
      >
        <v-col>{{ item.text }}</v-col>
        <v-col>{{ item.value }}</v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { PARTY_NAMESPACE } from '@/store/party'
import { humanize } from '@/utilities/string-utilities'
import { mapGetters } from 'vuex'

export default {
  name: 'BackgroundOverviewSummary',

  data () {
    return {
      items: [
        { prop: 'num_entries', value: null },
        { prop: 'date_first_entry', value: null },
        { prop: 'date_first_entry_uncertain', value: null },
        { prop: 'departed_since_first_entry', value: null },
        { prop: 'date_last_entry', value: null },
        { prop: 'date_last_entry_uncertain', value: null },
        { prop: 'any_enforcement_history', value: null },
        { prop: 'any_benefits_history', value: null },

      ],
    }
  },

  computed: {
    summaryItems () {
      return this.items.map(item => ({ ...item, text: humanize(item.prop), value: this.peParty[item.prop] }))
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },
}
</script>
